import React from 'react';
import { formatCount } from '../../fields.utils';
import { Bar, Text, BackButton } from './DraftBar.styles';

export const DraftBar = ({ selected, capPerAcre, capMax, onBack }) => (
  <Bar data-testid='draft-bar'>
    <b>Draft pick list</b>
    <Text>
      {formatCount(selected)} stones, biggest first, capped at{' '}
      {(capPerAcre ?? capMax).toFixed(2)} per acre. The survey is untouched.
    </Text>
    <BackButton type='button' onClick={onBack}>
      Back to the full field
    </BackButton>
  </Bar>
);
